import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "lead" }

import { computed } from 'vue'
    import type { ScaleTemplateViewerViewModel } from "@Scales/Components/ScaleTemplateViewer"

    /* props */
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ScaleTemplateViewer',
  props: {
    viewModel: {}
  },
  setup(__props: any) {

    const props = __props

    /* shortcuts */
    const vm = computed(() => props.viewModel)

    /* derived */

    const opened = computed(() => vm.value?.opened ?? false)
    const name = computed(() => vm.value.name)
    const description = computed(() => vm.value.description)
    const levels = computed(() => vm.value.levels)

    /* actions */

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(name.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(description.value), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levels.value, (lvl) => {
                  return (_openBlock(), _createElementBlock("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(lvl.Value) + " - " + _toDisplayString(lvl.Name), 1 /* TEXT */),
                    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createElementVNode("span", null, _toDisplayString(lvl.Definition), 1 /* TEXT */)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})